import React, { useEffect, useState } from "react"

const Item = props => {
  const [index, setindex] = useState(props.index)
  const [id, setid] = useState(props.id)
  const [value, setvalue] = useState(props.value)
  const [checked, setchecked] = useState(props.checked)

  useEffect(() => {
    setchecked(props.checked)
  }, [props.checked])

  const changeChecked = e => {
    if (e.target.checked) {
      setchecked(true)
    } else {
      setchecked(false)
    }
    props.update(index, e.target.checked)
  }

  return (
    <div className="form-check">
      <input
        onChange={changeChecked}
        type="checkbox"
        className="form-check-input"
        checked={checked}
      ></input>
      <label className="form-check-label">{props.value}</label>
    </div>
  )
}

export default Item
